if (!customElements.get('approval-compare-item')) {
    class ApprovalCompareItem extends HTMLElement {

        constructor() {
            super();
            this.key = this.dataset.key;
            this.originalKey = this.key;
            this.item = JSON.parse(document.querySelector(`[data-item="${this.key}"]`).innerText);
            this.checkoutChangedModal = document.getElementById('checkout-changed');
            this.checkoutErrorModal = document.getElementById('checkout-response-error');
        }

        async handleSubmit({ url, body }) {
            return fetch(`${url}.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Bypass-Internal': 'true',
                    // 'No-Queue': 'true'
                },
                body: JSON.stringify(body)
            });
        }

        async handleMainChange(quantity) {

            if (this.item.quantity == quantity) {
                return;
            }

            this.item.properties = {
                ...this.item.properties,
                '_resolved': true
            };

            const removeElement = document.querySelector(`approval-remove[data-key="${this.item.key}"]`);

            const add = this.item.quantity == 0;

            console.log(`this.item >>`,this.item, `add >>`,add);

            const line_key = `${this.item.id}:${generateUniqueStringWithTimestamp()}`;

            if(add){
                LocalCart.addItem({
                    id: parseInt(this.item.id),
                    key: line_key,
                    variant_id: parseInt(this.item.id),
                    price: price,
                    quantity: quantity,
                    properties: this.item.properties,
                    line_price: parseInt(price) * quantity,
                    original_line_price: parseInt(price) * quantity,
                    final_line_price: parseInt(price) * quantity
                });
            }else{
                LocalCart.updateQuantity(this.item.id, quantity);
                LocalCart.updateProps(this.item.id, this.item.properties)
            }
            
            this.item.quantity = quantity;
            const existingKey = this.item.key;
            add ? this.item.key = line_key : this.item.key = existingKey;

            document.querySelector(`[data-item="${this.originalKey}"]`).innerText = JSON.stringify(this.item);

            await window.checkout.handleUpdate(false, false);
        }

        async handleAlternativeChange({ variantId, quantity, price, identifier, depositReference, main, key, handle, origin }) {

            if (main) {

                await this.handleMainChange(quantity);

                origin.quantity = quantity;

            } else if (key == null && origin.quantity != quantity) {

                const line_key = `${variantId}:${generateUniqueStringWithTimestamp()}`;
                const addPros = {
                    '_price': price,
                    '_identifier': identifier,
                    '_is_alternative_product': true,
                    ...(depositReference ? { '_deposit_reference': depositReference } : {})
                }

                LocalCart.addItem({
                    id: parseInt(variantId),
                    key: line_key,
                    variant_id: parseInt(variantId),
                    price: price,
                    line_price: parseInt(price) * quantity,
                    original_line_price: parseInt(price) * quantity,
                    final_line_price: parseInt(price) * quantity,
                    quantity: quantity,
                    sku: identifier,
                    handle: handle,
                    properties: addPros
                });

                origin.key = line_key;
                origin.quantity = quantity;

                await window.checkout.handleUpdate(false, false);

            } else if (origin.quantity != quantity) {

                LocalCart.updateQuantity(variantId, quantity);

                if (quantity == 0) {
                    origin.key = null;
                }

                origin.quantity = quantity;

                await window.checkout.handleUpdate(false, false);
            }

            document.querySelectorAll(`quantity-input[data-variant-id="${variantId}"]`).forEach((el) => {
                el.quantity = quantity;
                el.updateStatus();
            });
        }
    }

    customElements.define('approval-compare-item', ApprovalCompareItem);
}

